import "./styles.scss";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useApp } from "context/app";

import NotifyContainer from "components/NotifyContainer";
import AnimatedGradient from "components/AnimatedGradient";

import { ReactComponent as Logo } from "assets/icons/white-logo.svg";
import { ReactComponent as BackArrow } from "assets/icons/new/back-arrow.svg";

import gradient_props from "libs/gradient_props";

const mainClass = "auth-layout";

const AuthLayout = ({ children }) => {
  const { t, i18n } = useTranslation();
  const { theme } = useApp();

  const { time, seed, colors } = gradient_props.blue;

  return (
    <>
      <div className={mainClass}>
        <div className={`${mainClass}__left`}>
          <div className={`${mainClass}__left__wrapper`}>
            <Logo />
            <Link
              to={`https://webinity.com/${i18n?.language === "pl" ? "pl" : ""}`}
              className={`${mainClass}__left__back-button`}
            >
              <BackArrow /> {t("Back to homepage")}
            </Link>
            <span className={`${mainClass}__left__bottom`}>
              {t(
                "Comprehensive support for websites based on WordPress and WooCommerce.",
              )}
            </span>
          </div>
          <div className={`${mainClass}__left__background`}>
            <AnimatedGradient
              id="auth-gradient"
              time={time}
              seed={seed}
              colors={colors[theme]}
            />
          </div>
        </div>
        <div className={`${mainClass}__right`}>
          <div className={`${mainClass}__right__content`}>{children}</div>
        </div>
      </div>

      <NotifyContainer />
    </>
  );
};

export default AuthLayout;
